import Splide from '@splidejs/splide';
export const init = () => {
    if (document.querySelector('.carousel_type-8')) {
        const carousel8 = document.querySelectorAll('.carousel_type-8');
        carousel8.forEach((item) => {
            const autoplayButton = item.querySelector('.splide__toggle');
            const arrowLeft = item.querySelector('.button--prev');
            const arrowRight = item.querySelector('.button--next');
            const splideCarousel8 = new Splide(item, {
                arrows: false,
                pagination: true,
                autoplay: 'pause',
                interval: 2000,
                perPage: 1,
                rewind: true,
                classes: {
                    pagination: 'splide__pagination g-pagination__type-1',
                },
                drag: false,
            },);
            splideCarousel8.mount();
            
            const { Controller, Autoplay } = splideCarousel8.Components;
            if (Controller.getNext() === -1) {
                arrowLeft.parentElement.classList.add('hidden');
                autoplayButton.classList.add('hidden');
            }
            splideCarousel8.on('move', (newIndex) => {
                if (Controller.getIndex() === Controller.getEnd()) {
                    Autoplay.pause();
                }
                switch (newIndex) { 
                    case 0: 
                        arrowLeft.classList.add('disabled'); 
                        arrowRight.classList.remove('disabled');
                        break;
                    case Controller.getEnd():
                        arrowRight.classList.add('disabled');  
                        arrowLeft.classList.remove('disabled');
                        break;
                    default:
                        arrowLeft.classList.remove('disabled');
                        arrowRight.classList.remove('disabled');  
                } 
            });
            arrowLeft.addEventListener('click', () => {
                Controller.go('<');
                Autoplay.pause();
            });
            arrowRight.addEventListener('click', () => {
                Controller.go('>');
                Autoplay.pause();
            });
            autoplayButton.addEventListener('click', () => {
                if (!Autoplay.isPaused()) {
                    Controller.go('>');
                }
            });
            splideCarousel8.on('move', () => {
                item.querySelectorAll('.splide__pagination__page').forEach((button) => {
                    button.addEventListener('click', () => {
                        Autoplay.pause();
                    });
                });
            }); 
        });
    }
}